/**
 * Feature Control source of truth: OpsPilot is enabled only after the org has
 * initialized settings and the toggle is on.
 *
 * Do not use useIsOpsPilotEnabled().opsPilotStatus === 'on' here — that hook
 * also returns 'on' for legacy orgs that never toggled Feature Control.
 */
export const isOpsPilotEnabledForOnboarding = ({
  organizationInitialized,
  enabled,
}: {
  organizationInitialized?: boolean;
  enabled?: boolean;
}): boolean => Boolean(organizationInitialized && enabled);
